import { connect } from 'react-redux'
import { reduxForm, getFormValues, change } from 'redux-form/immutable'
import i18next from 'i18next'

import { TIME_PREFERENCES_FORM } from 'app/constants/profile'
import { modal } from 'store/entities/modal/actions'
import ConfirmationNotificationTypeForm from './ConfirmationNotificationTypeForm'
import { saveProfile } from 'store/entities/identity/actions'
import { getIdentityFirstLoginFlow } from 'store/entities/identity/selectors'

const formProps = {
  form: 'CONFIRMATION_NOTIFICATION_TYPE_FORM',
  initialValues: {
    notificationType: null,
  },
}

const mapStateToProps = state => ({
  description: i18next.t(
    `user:We notice you have a mobile number entered. Are you sure you don’t want to receive notifications via text message?`
  ),
  timePreferencesFormValues: getFormValues(TIME_PREFERENCES_FORM)(state),
  isLoginFlowFinished: getIdentityFirstLoginFlow(state),
})

const dispatchToProps = {
  saveProfile,
}

const mergerProps = (
  { timePreferencesFormValues, isLoginFlowFinished, ...stateProps },
  { saveProfile, ...dispatchProps },
  { changeIsShowConfirmationNotificationType, ...ownProps }
) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    timePreferencesFormValues,
    changeIsShowConfirmationNotificationType,
    onChange: (values, dispatch) => {
      const notificationType = values.get('notificationType')
      const isNotificationTypeNull = notificationType !== null
      if (isNotificationTypeNull && isLoginFlowFinished) {
        dispatch(modal.hide())
        dispatch(saveProfile(timePreferencesFormValues.set('notificationType', notificationType)))
      }
      if (isNotificationTypeNull && !isLoginFlowFinished) {
        dispatch(change(TIME_PREFERENCES_FORM, 'notificationType', notificationType))
        changeIsShowConfirmationNotificationType(false)
      }
    },
  }
}

export default connect(mapStateToProps, dispatchToProps, mergerProps)(
  reduxForm(formProps)(ConfirmationNotificationTypeForm)
)
